var _defs, _use;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMoney = function SvgMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M32 0H4v4H0v17.333h28v-4h4V0Zm-5.333 20H1.333V5.333h25.334V20Zm4-4H28V4H5.333V1.333h25.334V16ZM14 17.333A4.667 4.667 0 1 0 14 8a4.667 4.667 0 0 0 0 9.333Zm0-8A3.333 3.333 0 1 1 14 16a3.333 3.333 0 0 1 0-6.667Z",
    id: "money_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#money_svg__a",
    transform: "translate(0 5)",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};
export default SvgMoney;